import ResultOfferCard from './ResultOfferCard';
import { formatResultDate, locationCode } from '../../utils/resultDisplay';
import { SITE_NAME } from '../../constants/site';

export default function HotelResultCard({ item, searchParams }) {
  const destCode = locationCode(item.destination);
  const checkIn = formatResultDate(searchParams?.get('checkIn'));
  const checkOut = formatResultDate(searchParams?.get('checkOut'));
  const bookingLines = [
    { label: 'Hotel', value: item.name },
    { label: 'Destination', value: item.destination },
    { label: 'Check-in', value: searchParams?.get('checkIn') },
    { label: 'Check-out', value: searchParams?.get('checkOut') },
    { label: 'Hotel class', value: `${item.stars} stars` },
    { label: 'Total price', value: `$${item.price.toFixed(2)}` },
  ];

  return (
    <ResultOfferCard
      dateLabel={checkIn}
      providerName={item.name}
      providerFallback={destCode}
      routeLeft={{ code: destCode, time: checkIn }}
      routeRight={{ code: `${item.rooms}R`, time: checkOut }}
      routeDuration={`${item.stars}★ Hotel`}
      routeStops={`${item.rooms} room(s)`}
      price={{ amount: item.perNight ?? item.price, currency: 'USD' }}
      pricePerLabel="Price per night"
      priceFinePrint={`Sample stay total $${Number(item.price).toFixed(2)} — not a live price`}
      detailsTitle="Hotel Details"
      detailRows={[
        { label: 'Destination', value: item.destination },
        { label: 'Address', value: item.address },
        { label: 'Amenities', value: item.amenities?.join(', ') },
        { label: 'Guests', value: String(item.guests || '—') },
      ]}
      bookNowProps={{
        serviceType: 'hotel',
        bookingPayload: {
          subject: `${SITE_NAME} — Hotel booking`,
          bookingLines,
          offer: {
            name: item.name,
            destination: item.destination,
            checkIn,
            checkOut,
            stars: item.stars,
            rooms: item.rooms,
            address: item.address,
          },
          price: {
            base: item.perNight ?? item.price,
            total: item.price,
            travelerLabel: `${item.rooms || 1} Room(s)`,
          },
        },
      }}
    />
  );
}
